<template>    
    <v-dialog
      v-model="dialog"
      width="500"
      persistent
    >      
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
            Sesión caducada
        </v-card-title>
        
        <v-layout wrap align-center mt-2 mb-2>
            <v-flex xs10 offset-xs1>                
                Se ha producido un inicio de sesión con sus credenciales en otro dispositivo. Se el devolverá a la pantalla de inicio.
            </v-flex>                                
        </v-layout>                

        <v-card-actions>
            <v-btn
                color="primary"
                text
                @click="closeOK"
            >
                Ok
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>  
</template>
<script>
export default {
    name: 'dialogLogout',
    data () {
      return {               
      }
    },
    methods:{        
        close(){
            this.$store.commit("logout");                   
        },
        closeOK(){   
            this.$store.commit("logout");                     
        }
    },
    mounted(){
    },
    watch:{
    },
    computed:{
        dialog: {
            get(){
                return this.$store.state.dialogLogout;
            },
            set(value){
                this.$store.state.dialogLogout = value;
            }
        }
    }
}
</script>

